import { useEffect, useState } from 'react';

// Types
import { IAoyTableRow } from '../types';

// Util
import * as api from '../util/api';
import { refreshRate } from './../util/util';
import pointsStandingsParams from './../util/pointsStandingsParams';

const AoyType = {
  1191: 'd1',
  1190: 'd1',
  1201: 'd2',
  1200: 'd2',
  1211: 'd3',
  1210: 'd3',
  91: 'elite',
  90: 'elite',
  99: 'eqs',
  501: 'opens',
  500: 'opens',
  531: 'eastern',
  530: 'eastern',
  511: 'northern',
  510: 'northern',
  551: 'central',
  550: 'central',
  521: 'southern',
  520: 'southern',
  541: 'western',
  540: 'western',
  1: 'kayak',
}

// Optional year on query
const apiUri = (tms, year, type) => `/wp-json/data/v1/angler/points?angler_id=${tms}&${pointsStandingsParams(type, year)}`;

const AOY_FETCH_RATE = refreshRate([60000, 60000]);

// Hook will return the AOY historic.
const useAoyAngler = (tms: number, year?: number, type?: string) => {
  const [aoyAngler, setAoyAngler] = useState<IAoyTableRow[]>([]);

  useEffect(() => {
    /**
     * Set state for the AOY historic when api returns.
     * NOTE: *returns a function to capture scope*
     */
    const storeAoyAngler = () => (response: IAoyTableRow[]) => {
        setAoyAngler(response);
    };

    (async () => {
      await api.subscribe({
        callback: storeAoyAngler(),
        rate: AOY_FETCH_RATE,
        uri: apiUri(tms, year, type),
      });
    })();
  }, [tms, year, type]);

  return aoyAngler;
};

export default useAoyAngler;
